import { useCallback } from 'react';
import { EndPoints } from 'src/config';
import { useFetcher } from 'src/hooks/useFetcher';
import { DeliveryPublicColiFetchPayload, DeliveryPublicColiInfoDataModel } from '../delivery-public-colis-info.types';

type Props = {
  includeTimeSlots?: boolean;
};
export const useDeliveryPublicColiInfo = ({ includeTimeSlots = false }: Props) => {
  const { fetcher, isLoading, data, error } = useFetcher<DeliveryPublicColiInfoDataModel | null>(null);

  const fetchData = useCallback(
    ({ code, tracking }: DeliveryPublicColiFetchPayload) => {
      fetcher(EndPoints.deliveryPublicColiInfo, {
        requiredToken: false,
        body: {
          code,
          tracking,
          includeTimeSlots: includeTimeSlots,
        },
      });
    },
    [fetcher, includeTimeSlots],
  );

  return {
    fetchData,
    isLoading,
    data,
    error,
  };
};
